module.exports = __webpack_public_path__ + "img/wing-right.e60f54bc.svg";